import { generateUniqueId } from 'canoe/utils';
import { emptySingleRuleGroup } from 'dashboard/pages/Segment/components/constants';
import {
  SegmentBaseDefinition,
  SegmentDefinition,
  SegmentNestedDefinition,
  SegmentSingleDefinition,
  SingleRuleKey,
} from 'dashboard/pages/Segment/components/types';

import { mappers } from './DefintionMapping';

const adjustDefinition = (definition: { [key: string]: any }) => {
  const { groups, ...rest } = definition;
  const data = { ...rest } as SegmentDefinition;

  if (groups && groups.length) {
    data.groups = groups.map(adjustDefinition);
    // give each group a unique ID for rendering purposes
    data.groupId = generateUniqueId();
    return data;
  }

  const { type } = data as SegmentSingleDefinition;
  return mappers[type as SingleRuleKey].definitionToForm(data);
};

const parseDefinition = (
  definition: SegmentBaseDefinition | SegmentSingleDefinition | SegmentNestedDefinition,
) => {
  // remove group ID as we don't need that for submission
  const { groupId, ...data } = definition;

  if (definition.groups && definition.groups.length) {
    data.groups = definition.groups.map(parseDefinition);
    return data;
  }

  const type = (data as SegmentSingleDefinition).type.includes('Seen')
    ? 'UserSeen'
    : (data as SegmentSingleDefinition).type;
  return mappers[type as SingleRuleKey].formToDefinition(data);
};

export const adjustInitialValues = (definition: { [key: string]: any }): SegmentDefinition =>
  definition.object === 'Any' && (!definition.groups || !definition.groups.length)
    ? emptySingleRuleGroup
    : adjustDefinition(definition);

export const parseSegmentValues = (definition: SegmentDefinition): SegmentDefinition => ({
  ...parseDefinition(definition),
  groups:
    definition.groups && definition.groups.length
      ? definition.groups.map(parseDefinition)
      : definition.groups,
});
